import {
	createDirectus,
	rest,
	authentication,
	type DirectusClient,
	type AuthenticationClient,
	type RestClient
} from '@directus/sdk';
import { PUBLIC_APIURL } from '$env/static/public';
import type { Fetch } from '$lib/Fetch';

let instance: DirectusClient<any> & AuthenticationClient<any> & RestClient<any>;

async function getDirectusInstance(
	fetch?: Fetch
): Promise<DirectusClient<any> & AuthenticationClient<any> & RestClient<any>> {
	if (instance) {
		return instance;
	}
	const options = fetch ? { globals: { fetch } } : {};

	const directus = createDirectus(PUBLIC_APIURL, options)
		.with(authentication('cookie', { credentials: 'include' }))
		.with(rest({ credentials: 'include' }));

	instance = directus;

	return directus;
}

export default getDirectusInstance;
